@use "variables" as *;

.list {
  overflow: auto;
  min-height: 170px;
}

.title {
  font-size: $fontSize-xs;
  font-weight: normal;
  margin-left: $spacing-l !important;
}

.loadingIndicator {
  width: 19px !important;
  height: 19px !important;
}

.trackListTitle {
  height: 36px;
}

.playButton {
  width: 82px;
  border-radius: 0 !important;
}
